var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Phone_svg__a",
    d: "M0 0h16.2v16.2H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Phone_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Phone_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.842 12.426a.884.884 0 01.08 1.353l-1.767 1.767c-1.77 1.77-7.178-.295-10.192-3.309C.949 9.223-1.117 3.815.653 2.045L2.423.277a.883.883 0 011.352.08L5.9 3.082c.347.444.303 1.13-.095 1.528L4.642 5.772c-.4.4-.5 1.12-.205 1.607 0 0 .573 1.159 1.9 2.485 1.325 1.326 2.484 1.9 2.484 1.9.488.286 1.209.193 1.607-.205l1.163-1.164c.4-.4 1.085-.44 1.529-.095l2.722 2.126z",
    fill: "#000",
    mask: "url(#Phone_svg__b)"
  }))));
}
export default SvgPhone;